import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../api/api';
import { useFormik } from 'formik';
import * as yup from "yup";
import TabTitle from '../components/TabTitle';

export default function EmailVerify() {
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { email: initialEmail } = location.state || {};

    const validationSchema = yup.object({
        email: yup
            .string("Enter email address")
            .email("Enter a valid email")
            .required("Email address is required"),
        otp: yup
            .string("Enter OTP")
            .min(1, "OTP is required")
            .max(6, "OTP must be at most 6 characters")
            .required("OTP is required"),
    });

    const formik = useFormik({
        initialValues: {
            email: initialEmail || "",
            otp: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                setIsSubmitting(true);
                setMessage('');
                const response = await api.put('/assessment/email_otp/', values);
                setMessage("Email verified successfully!");
                setIsSubmitting(false);
                setTimeout(() => {
                    navigate('/admin/login');
                }, 1500);
            } catch (error) {
                setIsSubmitting(false);
                setMessage(error.response?.data?.message || 'An error occurred. Please try again.');
            }
        }
    });

    useEffect(() => {
        if (initialEmail) {
            formik.setFieldValue('email', initialEmail);
        }
    }, [initialEmail]);

    return (
        <div>
            <TabTitle title="Verify Email" />
            <div className="d-flex justify-content-center align-items-center full-height-background">
                <div className="col-10 p-sm-8 col-md-5 col-lg-5 col-xl-4" style={{ opacity: "0.85" }}>
                    <div className="card p-4 p-md-5 p-sm-3 my-4">
                        <form className='signup-form' onSubmit={formik.handleSubmit}>
                            <h2 className='mb-4 mb-sm-5 text-center fw-bold'>Verify Email</h2>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email<span className="text-danger">*</span></label>
                                <input
                                    type="email"
                                    className="form-control forminput-custom"
                                    id="email"
                                    name="email"
                                    placeholder="name@example.com"
                                    value={formik.values.email}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    readOnly
                                    required
                                />
                                {formik.touched.email && formik.errors.email && (
                                    <small className="form-text text-danger">{formik.errors.email}</small>
                                )}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="otp" className="form-label">OTP<span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control forminput-custom"
                                    id="otp"
                                    name="otp"
                                    placeholder="Enter OTP"
                                    value={formik.values.otp}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 6); }}
                                    maxLength={6}
                                    required
                                />
                                {formik.touched.otp && formik.errors.otp && (
                                    <small className="form-text text-danger">{formik.errors.otp}</small>
                                )}
                            </div>
                            <div className="d-grid">
                                <button type="submit" className="btn btn-success" disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            <span className="sr-only">Verifying...</span>
                                        </>
                                    ) : "Verify Email"}
                                </button>
                            </div>
                        </form>
                        {message && <div className="mt-3 alert alert-info">{message}</div>}
                    </div>
                </div>
            </div>
        </div>
    );
} 